<template>
  <v-row no-gutters>
    <v-col>
      <v-row no-gutters class="borderTop pt-6 pb-6">
        <v-col cols="auto" class="mr-2" align-self="center">
          <v-icon color="info">
            mdi-information
          </v-icon>
        </v-col>
        <v-col class="text-left pr-16" cols="9">
          {{ $i18n.t('dialog.body.ruleInfo') }}
        </v-col>
      </v-row>
      <v-row no-gutters class="mb-10">
        <v-col cols="6" v-if="isSimple">
          <v-row no-gutters class="pb-6">
            {{ $i18n.t('dialog.body.examples') }}
          </v-row>
          <v-row no-gutters class="pb-4 text-left">
            {{ $i18n.t('dialog.body.simpleRuleExample1') }}
          </v-row>
          <v-row no-gutters>
            <v-col class="ruleOverview text-left" cols="auto">
              {{ $i18n.t('dialog.body.simpleRuleExample1Literal') }}
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-4 pt-8 text-left">
            {{ $i18n.t('dialog.body.simpleRuleExample2') }}
          </v-row>
          <v-row no-gutters>
            <v-col class="ruleOverview text-left" cols="auto">
              {{ $i18n.t('dialog.body.simpleRuleExample2Literal') }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" v-else>
          <v-row no-gutters class="pb-6 text-left">
            {{ $i18n.t('dialog.body.example') }}
          </v-row>
          <v-row no-gutters class="text-left pb-10">
            {{ $i18n.t('dialog.body.advancedRuleExample1') }}
          </v-row>
          <v-row no-gutters class="ruleOverview text-left">
            <v-col>
              <v-row no-gutters>{{ $i18n.t('dialog.body.advancedRuleLine1') }}</v-row>
              <v-row no-gutters>{{ $i18n.t('dialog.body.advancedRuleLine2') }}</v-row>
              <v-row no-gutters>{{ $i18n.t('dialog.body.advancedRuleLine3') }}</v-row>
              <v-row no-gutters>{{ $i18n.t('dialog.body.advancedRuleLine4') }}</v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="4" class="borderAll">
          <v-sheet color="#f3f3f3" class="pa-2 pb-4 text-left">
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> P </span> {{ $i18n.t('dialog.body.rulesExplanationPipes') }}
            </v-row>
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> PUMP </span> {{ $i18n.t('dialog.body.rulesExplanationPumps') }}
            </v-row>
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> GPV </span> {{ $i18n.t('dialog.body.rulesExplanationGPV') }}
            </v-row>
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> V </span> {{ $i18n.t('dialog.body.rulesExplanationValves') }}
            </v-row>
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> J </span> {{ $i18n.t('dialog.body.rulesExplanationJunctions') }}
            </v-row>
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> R </span> {{ $i18n.t('dialog.body.rulesExplanationReservoirs') }}
            </v-row>
            <v-row no-gutters class="py-1 text-body-2">
              <span class="font-weight-bold pr-1"> T </span> {{ $i18n.t('dialog.body.rulesExplanationTanks') }}
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ModelingRuleInfo',
  props: {
    isSimple: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.borderTop {
  @include border(top);
}
.borderAll {
  @include border();
  border-color: rgba(0, 0, 0, 0.12);
}
.ruleOverview {
  padding-right: 4px;
  padding-left: 4px;
  font-weight: 500;
  color: #188038;
  background-color: #f3f3f3;
}
</style>
